import React from 'react';
import PropTypes from 'prop-types';

class SlidingCounter extends React.Component {
  //setup
  constructor(props) {
    super(props);
  }

  //getters
  getColor(){
    let ratio = this.getRatio();

    if (ratio < .5){
      return "grey";
    } else if (ratio < .8){
      return "yellow";
    } else if (ratio <= 1){
      return "orange";
    } else {
      return "red"
    }
  }

  getRatio(){
    return this.props.currentTotal / this.props.limit;
  }

  getPaddingRight(){
    if (this.props.currentTotal >= this.props.limit) {
      return 0;
    }

    let reverseRatio = 1 - this.getRatio();
    return reverseRatio * this.getWidth();
  }

  getWidth(){
    return this.props.width || 400;
  }

  getDecimalPlaces() {
    return this.props.decimalPlaces;
  }

  getVisibleTotal() {
    const {
      currentTotal,
    } = this.props;

    return currentTotal.toFixed(this.getDecimalPlaces());
  }

  getVisibleLimit() {
    const {
      limit,
    } = this.props;

    return limit.toFixed(this.getDecimalPlaces());
  }

  //actions


  //render
  render() {
    let paddingRight = this.getPaddingRight();
    let width = this.getWidth();

    return (
      <div className={"sliding-counter " + this.getColor()}
        style={{
          width
        }}
      >
        <div className="color-filler-container" style={{paddingRight}}>
          <div className="color-filler"/>
        </div>
        <div className="slider-text">
          {this.getVisibleTotal()} / {this.getVisibleLimit()} {this.props.units || ""}
        </div>
      </div>
    );
  }

}

SlidingCounter.propTypes = {
  limit: PropTypes.number.isRequired,
  currentTotal: PropTypes.number.isRequired,
  decimalPlaces: PropTypes.number.isRequired,
};

export default SlidingCounter;



// WEBPACK FOOTER //
// ./src/components/purchase_limits/sliding_counter.jsx